import { Entities, TOMCAT_URL } from 'src/common/index';
import { apiRequest } from 'src/actions/api/api';

export function deleteTripCategory(categoryId) {
    return dispatch => {
        return dispatch(
            apiRequest({
                endpoint: `${TOMCAT_URL}api/${Entities.TRIP_CATEGORY.repository}/removeTripCategory?categoryId=${categoryId}`,
                method: 'DELETE',
                secondaryActionTypes: [
                    `REQUEST_${Entities.TRIP_CATEGORY.action}`,
                    `SUCCESS_DELETE_${Entities.TRIP_CATEGORY.action}`,
                    `FAILURE_${Entities.TRIP_CATEGORY.action}`,
                ],
                schema: Entities.TRIP_CATEGORY.schema,
                reducerIndex: 0,
                parameter: categoryId,
            }),
        );
    };
}
